<template>
    <div>
        <h1>{{ BILLING_SHOW($route.params.id).name }}</h1>
        <v-data-table
            :headers="headers"
            :items="BILLING_SHOW($route.params.id).lines"
            hide-actions
            class="elevation-1"
            pagination.sync="pagination"
            loading="true"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.article }}</td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.price.toFixed(2).replace(".", ",") }} €</td>
                <td>{{ props.item.qty_confirmed + ' ' + props.item.unit}}</td>
                <td>{{ props.item.price_discounted.toFixed(2).replace(".", ",") }} €</td>
                <td>{{ props.item.price_total.toFixed(2).replace(".", ",") }} €</td>
            </template>
            <template slot="no-data">
                <p>{{ $vuetify.t('$vuetify.lobis.noResultsForPosition') }}</p>
            </template>
            <template slot="footer">
                <td :colspan="headers.length -1">
                    <strong>{{ $vuetify.t('$vuetify.lobis.billingAmount') }}:</strong>
                </td>
                <td>
                    {{ BILLING_SHOW($route.params.id).amount.toFixed(2).replace(".", ",") }} €
                </td>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BILLING_SHOW, BILLING_GET } from '../../store/actions/billing'

export default {
  data () {
    return {
      headers: [
        {
          text: 'Artikel',
          align: 'left',
          value: 'article'
        },
        {
          text: 'Name',
          align: 'left',
          value: 'name'
        },
        {
          text: 'Einzelpreis',
          align: 'left',
          value: 'price'
        },
        {
          text: 'Menge',
          align: 'left',
          value: 'qty_confirmed'
        },
        {
          text: 'Preis mit Skonto',
          align: 'left',
          value: 'price_discounted'
        },
        {
          text: 'Summe',
          align: 'left',
          value: 'price_total'
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      BILLING_SHOW
    ])
  },
  mounted () {
    this.$store.dispatch(BILLING_GET)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Billing/Show.vue